<template>
  <div>
    <h1>Frequently Asked Questions</h1>

    <div class="faq-item">
      <h3>Do I need to do anything before I use a Good Kid song in my video?</h3>
      <p>
        Nope. You can just use our songs.
      </p>
    </div>

    <div class="faq-item">
      <h3>Do I have to pay to use Good Kid music in my content?</h3>
      <p>
        No! We don't require any payment, we just love supporting creators! We'd
        only ask that you share the love in supporting us back and please credit
        us in your video's description and/or in the credit sequence on your
        video. Something along the lines of: &ldquo;Music provided Content ID free
        by @goodkidband&rdquo;
      </p>
    </div>

    <div class="faq-item">
      <h3>Will my content be muted on Twitch if I use Good Kid music?</h3>
      <p>
        No! We ensure our music is free to use on Twitch. Not only will your
        stream function as usual, your uploads will also never be muted.
      </p>
    </div>

    <div class="faq-item">
      <h3>Will my content be muted on Instagram or TikTok if I use Good Kid music?</h3>
      <p>
        No! As long as your content is under 30 seconds you should have no issues
        using our music on Instagram or TikTok!
      </p>
    </div>

    <div class="faq-item last">
      <h3>What is YouTube &ldquo;Content ID&rdquo;?</h3>
      <p>
        YouTube Content ID is a system that identifies copyrighted music in videos.
        We specifically make sure that our music is excluded from this system.
      </p>
    </div>
  </div>
</template>

<style scoped>
.faq-item {
  padding: 16px 0;
  border-bottom: 1px solid rgba(54, 47, 40, 0.12);
}

.faq-item.last {
  border-bottom: none;
  padding-bottom: 0;
}

.faq-item h3 {
  margin-bottom: 6px;
  color: #3f3a35;
}

.faq-item p {
  margin-top: 4px;
  color: #5c5347;
}
</style>
